import * as DomHelper from "../Helpers/DomHelper";
import * as BlobHelper from "../Helpers/BlobHelper";
import { cancel } from "../Helpers/ExecutionStatus";
import { postRequest } from "../Helpers/AjaxHelper";
const global = window;
const { selfHelp: { resources } } = global;
const { statusIconVals } = DomHelper;
const cookieTestKey = "cookiePersistence";
const reqBodyTestKey = "requestBodyPersistence";
const cookieName = "selfHelpCookieName";
const cookieVal = "selfHelpCookieVal";
// object we send on post request to determine wheter values are being stripped or not
const sanityCheckObj = {
    testVal1: "string1",
    testVal2: "string2",
};
// used for resources file to amend strings
const testName = {
    cookiePersistence: "cookies",
    requestBodyPersistence: "request body",
};
/** Ends tests. Updates DOM and blob. Updates display icon to indicate tests finished. Ensures that if tests have been cancelled execution stops. */
function endTest(testKey, diagnostics) {
    if (cancel) {
        return;
    }
    BlobHelper.updateBlob(testKey, diagnostics);
    const displayStatus = diagnostics.success ? statusIconVals.success : statusIconVals.error;
    DomHelper.displayStatusIcon(testKey, displayStatus);
    DomHelper.createMoreDetailsSection(testKey, diagnostics.details);
    DomHelper.makeBarGrow(testKey);
}
/** Sets cookie in browser with thirty seconds expiration */
function setCookieInBrowser() {
    const date = new Date();
    const cookieExpirationDuration = 30000; // thirty seconds
    date.setTime(date.getTime() + cookieExpirationDuration);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${cookieName}=${cookieVal};${expires};path=/`;
}
/** Grabs cookie from browser */
function getCookie() {
    if (cancel) {
        return;
    }
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
        const c = cookieArray[i];
        const trimmedString = c.trim();
        if (trimmedString.startsWith(name)) {
            return trimmedString.substring(name.length, trimmedString.length);
        }
    }
    return "";
}
/**
 * Makes post request to server to determine whether cookies are stripped from headers.
 *
 * @param {string} testKey the key which corresponds to which test is being ran
 */
async function checkStrippedOnRequest(testKey, cookie) {
    if (cancel) {
        return;
    }
    const data = { sanityRequestObj: sanityCheckObj };
    let details;
    let diagnostics;
    if (testKey === cookieTestKey && cookie !== cookieVal) {
        diagnostics = {
            success: false,
            details: resources.CookiePersistence_setFailure,
        };
        return diagnostics;
    }
    const res = await postRequest("./SelfHelp/RequestSanityCheck", false, data);
    if (res.status === 500) {
        details = resources.ValuePersistence_deserializeError;
        diagnostics = {
            success: false,
            status: res.status,
            statusText: res.statusText,
            details,
        };
        return diagnostics;
    }
    if (res.status !== 200) {
        details = resources.ValuePersistence_unknownPostError.replace("{0}", res.status.toString()).replace("{1}", testName[testKey]);
        diagnostics = {
            success: false,
            status: res.status,
            statusText: res.statusText,
            details,
        };
        return diagnostics;
    }
    const resData = JSON.parse(res.responseText);
    const { cookiesValidated, reqBodyValidated } = resData;
    if (testKey === cookieTestKey) {
        details = cookiesValidated ? resources.CookiePersistence_success : resources.CookiePersistence_stripped;
        diagnostics = {
            success: cookiesValidated,
            details,
        };
        return diagnostics;
    }
    if (testKey === reqBodyTestKey) {
        details = reqBodyValidated ? resources.ReqBodyPersistence_success : resources.ReqBodyPersistence_stripped;
        diagnostics = {
            success: reqBodyValidated,
            details,
        };
        return diagnostics;
    }
}
/**
 * Triggers beginning of test, resets diagnostics, and updates icons to display test in progress
 *
 * @param {ValuePersistenceKeys} testKey a value of either "cookiePersistence" or "requestBodyPersistence" which dictates which test should be ran
 */
export function startTest(testKey) {
    DomHelper.displayStatusIcon(testKey, statusIconVals.inProgress);
    let cookie;
    if (testKey === cookieTestKey) {
        setCookieInBrowser();
        cookie = getCookie();
    }
    checkStrippedOnRequest(testKey, cookie)
        .then((diagnostics) => endTest(testKey, diagnostics));
}
//# sourceMappingURL=ValuePersistenceDiagnostics.js.map